import React from "react";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Checkbox, FormControlLabel } from "@mui/material";

export default function General({ formData, FORM_MODE, handleInputChange }) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              disabled
              name="Id"
              label="ID"
              value={formData?.Id}
              size="small"
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="Title"
              label="Titel"
              value={formData?.Title === null ? "" : formData?.Title}
              disabled
              onChange={(event) =>
                handleInputChange("Title", event.target.value)
              }
              size="small"
              color="primary"
              fullWidth
              margin="dense"
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="Name"
              label="Namn"
              value={formData?.Name === null ? "" : formData?.Name}
              disabled={FORM_MODE === "LOCKED" ? true : false}
              onChange={(event) =>
                handleInputChange("Name", event.target.value)
              }
              size="small"
              color="primary"
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="AccountNumber"
              label="Kontonummer"
              value={
                formData?.AccountNumber === null ? "" : formData?.AccountNumber
              }
              disabled={FORM_MODE === "LOCKED" ? true : false}
              onChange={(event) =>
                handleInputChange("AccountNumber", event.target.value)
              }
              size="small"
              color="primary"
              fullWidth
              margin="dense"
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="ExportedAccountName"
              label="Exporterat kontonamn"
              value={
                formData?.ExportedAccountName === null
                  ? ""
                  : formData?.ExportedAccountName
              }
              disabled={FORM_MODE === "LOCKED" ? true : false}
              onChange={(event) =>
                handleInputChange("ExportedAccountName", event.target.value)
              }
              size="small"
              color="primary"
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="ExportedAccountNumber"
              label="Exporterat kontonummer"
              value={
                formData?.ExportedAccountNumber === null
                  ? ""
                  : formData?.ExportedAccountNumber
              }
              disabled={FORM_MODE === "LOCKED"}
              onChange={(event) =>
                handleInputChange("ExportedAccountNumber", event.target.value)
              }
              size="small"
              color="primary"
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                textAlign: "left",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={FORM_MODE === "LOCKED"}
                    checked={!!Number(formData?.Export ?? 0)}
                    onChange={(event) =>
                      handleInputChange("Export", event.target.checked ? 1 : 0)
                    }
                  />
                }
                label="Export"
              />
            </div>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
